import { render, staticRenderFns } from "./HeadContactBookDetail.vue?vue&type=template&id=7c4db8ae&scoped=true&"
import script from "./HeadContactBookDetail.vue?vue&type=script&lang=js&"
export * from "./HeadContactBookDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeadContactBookDetail.vue?vue&type=style&index=0&id=7c4db8ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4db8ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VChip,VCol,VProgressCircular,VRow,VSpacer,VSwitch,VTextarea})
